import {
	Button, Dialog, DialogActions, DialogContent,
	DialogTitle, TextField, Tooltip
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react'
import { useActions, useValues } from 'kea';
import CircularProgress from '@material-ui/core/CircularProgress';

import grouplogic from 'src/store/group';
import alertlogic from 'src/store/alert';

const AssignGroupDialog = ({ selectedAlert }) => {
	const [open, setOpen] = React.useState(false);
	const [newGroups, setNewGroups] = React.useState(selectedAlert.groups.map((g) => g._id) || []);

	const { groups } = useValues(grouplogic);
	const { fetchAll: GroupFetchAll } = useActions(grouplogic);

	const { updateGroup } = useActions(alertlogic);

	React.useEffect(() => {
		groups ?? GroupFetchAll();
	}, []); // eslint-disable-line

	React.useEffect(() => {
		setNewGroups(selectedAlert.groups.map((g) => g._id) || [])
	}, [selectedAlert]);

	const handleClickOpen = () => {
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false)
	}

	const handleChange = (e, newValue) => {
		// console.log(newValue);
		// let update_groups = [...newGroups];
		const update_groups = newValue;
		setNewGroups(update_groups);
	}

	const handleEdit = () => {
		setOpen(false);
		selectedAlert.groups = newGroups;
		updateGroup(selectedAlert);
	}

	if (groups === null) return <CircularProgress />

	return (
		<div>
			<Tooltip title="Assign alert to Group(s)">
				<Button
					color="default"
					variant="contained"
					aria-label="update"
					size='large'
					onClick={handleClickOpen}
				>
					Group Assignment
				</Button>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">Assign this alert to Group(s)</DialogTitle>
				<DialogContent>
					<Autocomplete
						multiple
						id="tags-standard"
						options={groups.map((g) => g._id)}
						getOptionLabel={(option) => {
							return groups.filter((g) => {
								return g._id === option;
							})[0].name
						}}
						// defaultValue={alert.groups}
						size={'medium'}
						value={newGroups}
						filterSelectedOptions
						onChange={handleChange}
						renderInput={(params) => (
							<TextField
								{...params}
								variant="standard"
								label="Select Groups"
							// placeholder=""
							/>
						)}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handleEdit} color="primary">
						Assign
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}

export default AssignGroupDialog
